import { Grid, Typography } from '@mui/material';

type Props = {
  children: React.ReactNode;
  headerTitle: string;
};

const MainContainer = ({ children, headerTitle }: Props) => {
  return (
    <Grid
      container
      mt={2}
      p={3}
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '4px',
        alignSelf: 'stretch',
        background: '#FFF',
        height: `calc(100vh - 160px)`,
        overflow: 'auto',
        flexDirection: 'column',
        flexWrap: 'initial'
      }}
      data-testid="main-auth-container"
    >
      <Typography fontFamily={'Poppins'} fontSize={18} fontWeight={500} lineHeight={'32px'} color={'#000'} fontStyle={'normal'}>
        {headerTitle}
      </Typography>
      {children}
    </Grid>
  );
};

export default MainContainer;
